import PropTypes from "prop-types";

// Signature item
export const signatureItemShape = PropTypes.shape({
  file_name: PropTypes.string,
  assigned_on: PropTypes.string,
  assigned_by: PropTypes.string,
  due_on: PropTypes.string,
  status: PropTypes.string,
  notes: PropTypes.string,
  step_line: PropTypes.string,
  review_step: PropTypes.number,
  sent_by: PropTypes.string,
  can_cancel: PropTypes.bool,
});

// Veterans Affairs item
export const veteransAffairsItemShape = PropTypes.shape({
  id: PropTypes.number,
  file_name: PropTypes.string,
  matter_id: PropTypes.string,
  matter_name: PropTypes.string,
  sent_on: PropTypes.string,
  sent_by: PropTypes.string,
  status: PropTypes.string,
  error_acknowledged_at: PropTypes.string,
  filed_with: PropTypes.string,
  filed_with_label: PropTypes.string,
  copy_note: PropTypes.string,
  copy_of_upload_id: PropTypes.number,
  copy_upload_ids: PropTypes.arrayOf(PropTypes.number),
});

// Review (MyReview / SharedReview) item
export const reviewItemShape = PropTypes.shape({
  file_name: PropTypes.string,
  matter_id: PropTypes.string,
  matter_name: PropTypes.string,
  assigned_on: PropTypes.string,
  assigned_by: PropTypes.string,
  due_on: PropTypes.string,
  status: PropTypes.string,
  notes: PropTypes.string,
});

// Pagination
export const paginationShape = PropTypes.shape({
  count: PropTypes.number,
});

// Filter state
export const filterStateShape = PropTypes.objectOf(
  PropTypes.shape({
    chip_status: PropTypes.string,
    status: PropTypes.string,
    due_on: PropTypes.string,
    search: PropTypes.string,
    page: PropTypes.number,
    page_size: PropTypes.string,
  })
);

// Common table props
export const commonProps = {
  filterState: filterStateShape.isRequired,
  handleChangePageSize: PropTypes.func,
  currentPage: PropTypes.number,
  handlePageChange: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
  getRowProps: PropTypes.func,
};
